import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
// import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';
// import CardActions from '@material-ui/core/CardActions';
import Avatar from '@material-ui/core/Avatar';
// import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
// import { red } from '@material-ui/core/colors';
// import FavoriteIcon from '@material-ui/icons/Favorite';
// import ShareIcon from '@material-ui/icons/Share';
// import MiniDrawer from './Main';
// import Badge from '@material-ui/core/Badge';
import Grid from "@material-ui/core/Grid";
import translate from '../other/translate.json'

const useStyles = makeStyles((theme) => ({
	root: {
		// maxWidth: 345,
		boxShadow: '6px 6px 15px rgba(64, 102, 199, 0.02)',
		borderRadius: theme.spacing(2),
		padding: theme.spacing(3),
		backgroundColor: '#3C3C56',
		marginBottom: theme.spacing(3),
		height: 148
	},

	avatar: {
		backgroundColor: '#5b5b71',
		height: 62,
		width: 62,
		borderRadius: 24,
		float: 'left',
		marginRight: 24
	},

	icon: {
		marginLeft: 'auto',
	},

	content: {
		overflow: 'hidden',
		padding: 0
	},

	header: {
		title: {
			fontSize: 22
		}
	},

	bodyText: {
		color: '#BCBBD0',
		fontSize: 16,
		lineHeight: '24px'
	},

	bodyCount: {
		marginTop: 3,
		color: '#FFFFFF',
		fontSize: 28,
		lineHeight: '40px',
		fontWeight: 500
	},

	bodyText2: {
		color: '#BCBBD0',
		fontSize: 14,
		lineHeight: '18px',
		fontWeight: 500
	},
	link: {
		textDecoration: 'none'
	}
}));

export default function CardInfo(props) {
	const classes = useStyles();

	return (
		<a className={classes.link} href='/applications/cftbank/applist' >
			<Card className={classes.root}>
				<CardContent className={classes.content}>
					<Grid container direction="row">
						<Grid item>
							<Avatar className={classes.avatar}>
								<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
									<path d="M3.00685 14.7437C2.12507 14.396 1.96123 13.2185 2.7146 12.6433L14.7863 3.42664C15.5029 2.8795 16.4971 2.8795 17.2137 3.42664L29.2854 12.6433C30.0388 13.2185 29.8749 14.396 28.9931 14.7437C28.528 14.9271 28.2222 15.3763 28.2222 15.8763V25C28.2222 26.1046 27.3268 27 26.2222 27H5.77778C4.67321 27 3.77778 26.1046 3.77778 25V15.8763C3.77778 15.3763 3.47204 14.9271 3.00685 14.7437Z" fill="white" stroke="white" strokeWidth="2" />
									<rect opacity="0.5" x="8.5" y="18.5" width="1" height="15" rx="0.5" transform="rotate(-90 8.5 18.5)" fill="#8094FF" stroke="#8094FF" />
									<circle opacity="0.5" cx="16" cy="11" r="1" fill="#8094FF" />
									<path opacity="0.5" d="M11 19V27" stroke="#8094FF" strokeWidth="2" />
									<path opacity="0.5" d="M16 19V27" stroke="#8094FF" strokeWidth="2" />
									<path opacity="0.5" d="M21 19V27" stroke="#8094FF" strokeWidth="2" />
								</svg>
							</Avatar>
						</Grid>
						{props.count
							?
							<Grid item>
								<Typography className={classes.bodyText} component="p">
									{translate.Words[`CFT${props.lang}`]}
								</Typography>

								<Typography className={classes.bodyCount} component="p">
									{props.count}
								</Typography>

								<Typography className={classes.bodyText2} component="p">
									{translate.Words[`Applications${props.lang}`]}
								</Typography>
							</Grid>
							:
							''
						}
					</Grid>
				</CardContent>
			</Card>
		</a>
	);
}
